export interface FeaturedEntry {
  id: string;
  title: string;
  desc: string;
  tag: string;
  entries: number;
  updated: string;
  image: string;
  href: string;
}

export const featuredEntries: FeaturedEntry[] = [
  {
    id: "daily",
    title: "每日速报入口",
    desc: "一整天的新鲜料按时间线排好，从早到晚顺着往下翻，不用来回切站。适合只想花十分钟了解个大概的你。",
    tag: "推荐首位",
    entries: 128,
    updated: "12 分钟前",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20scattered%20gossip%20news%20cards%20and%20chat%20bubbles%20floating%20on%20warm%20cream%20background%2C%20terracotta%20orange%20and%20deep%20teal%20accents%2C%20minimal%20geometric%20editorial%20poster%20style%2C%20soft%20studio%20light%2C%20clean%20modern%20composition%2C%20high%20detail&width=800&height=500&seq=hlrk-fe-01&orientation=landscape",
    href: "#entries",
  },
  {
    id: "archive",
    title: "事件归档大厅",
    desc: "把零散的热搜回声归到同一条时间轴上，前因后果分栏陈列。想补课某件事的来龙去脉，从这里进最省事。",
    tag: "归档齐全",
    entries: 96,
    updated: "1 小时前",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20an%20organized%20archive%20shelf%20with%20labeled%20folders%20and%20glowing%20screens%20on%20warm%20cream%20background%2C%20terracotta%20orange%20and%20deep%20teal%20accents%2C%20minimal%20editorial%20poster%20style%2C%20soft%20natural%20light%2C%20clean%20modern%20composition%2C%20high%20detail&width=800&height=500&seq=hlrk-fe-02&orientation=landscape",
    href: "#collections",
  },
  {
    id: "filter",
    title: "分类筛选通道",
    desc: "按题材、按热度、按更新时间三重筛选，挑入口前先划好范围。信息密度高但结构清爽，找得准也找得快。",
    tag: "按类归好",
    entries: 214,
    updated: "今天",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20large%20magnifier%20over%20stacked%20documents%20and%20tags%20on%20warm%20cream%20background%2C%20terracotta%20orange%20and%20deep%20teal%20accents%2C%20minimal%20geometric%20editorial%20poster%20style%2C%20soft%20studio%20light%2C%20clean%20modern%20composition%2C%20high%20detail&width=800&height=500&seq=hlrk-fe-03&orientation=landscape",
    href: "#categories",
  },
  {
    id: "trend",
    title: "热度追踪榜单",
    desc: "近 24 小时呼声最高的入口集中排一行，热度变化带趋势箭头。懒人模式直接照着榜单从上往下点就完。",
    tag: "实时榜单",
    entries: 40,
    updated: "刚刚",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20megaphone%20and%20rising%20bar%20chart%20of%20trending%20signals%20on%20warm%20cream%20background%2C%20terracotta%20orange%20and%20deep%20teal%20accents%2C%20minimal%20geometric%20editorial%20poster%20style%2C%20soft%20studio%20light%2C%20clean%20modern%20composition%2C%20high%20detail&width=800&height=500&seq=hlrk-fe-04&orientation=landscape",
    href: "#rank",
  },
];